import React, { useEffect } from 'react';

// core components
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const SectionStyled = styled.div`
    min-width: 100%;
    min-height: 8vh;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    color: black;
    border-radius: 10px;
    :hover{
        background-color: #EB5E28;
        cursor: pointer;
    }
`;

export default function DragDrop({ setPictures }) {
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone();

    useEffect(() => {
        // Create objects that contain image data to make it possible to preview
        if (acceptedFiles.length > 0) {
            const files = acceptedFiles.map((file) => {
                const data = URL.createObjectURL(file)
                return { data_url: data, file }
            })
            if (files) {
                setPictures(files)
            }
        }
    }, [acceptedFiles, setPictures])

    return (
        <>
            <SectionStyled {...getRootProps()}>
                <input {...getInputProps()} accept="image/*" />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </SectionStyled>
        </>
    );
}